import { createSlice } from '@reduxjs/toolkit';
import { InvStatus } from '../../libs/constants';
import { InvoiceMasterData } from '../models/InvoiceMasterRequest';

export interface stateTypes {
  brandName: string,
  brandNo: string,
  invStatus:  string
  invAmount: number,
  fromDate: string,
  toDate: string,
  invMasterId: string,
  masterData: InvoiceMasterData | null,
}

const initialState: stateTypes = {
  brandName: "",
  brandNo: "",
  invStatus:  InvStatus.NOT_CONFIRMED,
  invAmount: 0,
  fromDate: "",
  toDate: "",
  invMasterId: "",
  masterData: null,
};

const invoiceMasterSlice = createSlice({
    name: 'invMaster',
    initialState,
    reducers: {
      saveMasterInfo (state, action) {
        const {masterData} = action.payload;
        return {...state, masterData}
      }
    }
})

export const {saveMasterInfo} = invoiceMasterSlice.actions;

export default invoiceMasterSlice.reducer;